import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";

// Router
import router from "@/router";

//Primevue
import PrimeVue from 'primevue/config';
import StyleClass from 'primevue/styleclass';
import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';
import { tooltipPt } from '@/volt/tooltipPt';
import ToastService from 'primevue/toastservice';

// Styling
import './style.css'

// Template components
import Gate from '@/components/authorization/Gate.vue';

// Template directives
import clickRipple from "@/directives/clickRipple";

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
})

// Craft new application
const app = createApp(App);

// Register global components
app.component("Gate", Gate);

// Register global directives
app.directive("click-ripple", clickRipple);

// Use Pinia and Vue Router
app.use(createPinia());
app.use(router);

// Add bugsnag to the app and use app-level provide for access
app.use(Bugsnag.getPlugin('vue'))

// Register global variables
app.config.productionTip = false;

app.use(PrimeVue, {
  unstyled: true,
  ripple: true,
  // Directives have no Volt wrapper, so their look is set here.
  pt: { directives: { tooltip: tooltipPt } }
})

app.use(ToastService);

app.directive('ripple', Ripple);
app.directive('styleclass', StyleClass);
app.directive('tooltip', Tooltip);

// ..and finally mount it!
app.mount("#app");
